import React, {useState, useEffect, useContext} from 'react';
import { Typography, Tooltip, Box} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTheme } from '@mui/material/styles';
import { route } from "/@/app/routes.jsx";
import {AppContext} from "/@/app/AppContext.js";
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import { formatDate } from "/@/app/utils.jsx";


const STYLE = {
    'free_2025': {
        Icon: null,
    },
    'premium_2025': {
        Icon: WorkspacePremiumIcon,
        tooltip: 'Премиум',
        sx: {color: 'yellow'},
    },
    'sponsor_ultimate_2025': {
        Icon: EmojiPeopleIcon,
        tooltip: 'Спонсор',
        sx: {color: 'yellow'},
    },
    '_default': {
        Icon: WorkspacePremiumIcon,
        tooltip: 'Подписка',
        sx: {color: 'white'},
    },
}

export const SubscriptionNote = ({ sx }) => {
    const theme = useTheme();
    const { main_plan } = useContext(AppContext).bootstrapData;
    const { main_plan_discount_notice_days } = useContext(AppContext).bootstrapData;
    const navigate = useNavigate();

    let style = STYLE[main_plan.name];
    if (!style) {
        style = STYLE['_default'];
    }

    const click = (e) => {
        navigate(route('/subscriptions/'))
    }

    const _sx = {
        color: theme.palette.primary.main,
        cursor: 'pointer',
        pb: 1,
        ...sx,
    }

    if (main_plan.name === 'free_2025') {
        return <></>;
    }

    return (
        <Box sx={ _sx } onClick={click} >
            <Typography variant="body2">
                <style.Icon sx={{
                    mr: 0.5,
                    fontSize: '16px',
                    position: 'relative',
                    top: '4px',
                }} />
                до {formatDate(main_plan.status.till)}
            </Typography>
            {main_plan_discount_notice_days > 0 &&
                <Typography variant="body2" sx={{ color: theme.palette.secondary.main }}>
                    бонус {main_plan_discount_notice_days} дней за импорт
                </Typography>
            }
        </Box>
    )
}

export const SubscriptionIcon = ({ sx }) => {
    const { main_plan } = useContext(AppContext).bootstrapData;
    const navigate = useNavigate();
    const click = (e) => {
        navigate(route('/subscriptions/'))
    }

    let style = STYLE[main_plan.name];
    if (!style) {
        style = STYLE['_default'];
    }

    const _sx = {
        mr: 1,
        ml: 1,
        cursor: 'pointer',
        position: 'relative',
        top: '5px',
        ...style.sx,
        ...sx,
    };

    if (main_plan.name === 'free_2025') {
        return <></>;
    }

    return (
        <Tooltip title={style.tooltip}>
            <style.Icon
                onClick={click}
                sx={_sx}
            />
        </Tooltip>
    );
}
